<template>
  <div>
    <div @click="click(tek.id)" v-if="tek.userProfile" class="tek" :class="{ selected: tek.index === tingtong }">
      <div class="profilePicture" :style="`background-image: url('${tek.userProfile.profilePictureURL}'`"></div>
      <span class="label small">{{ tek.userProfile.voornaam || "" }} {{ tek.userProfile.achternaam || "" }}</span>
      <div class="label small disciplines">
        <span
          class="discipline"
          v-for="(t, i) in tek.userProfile.disciplines"
          :key="i"
          :class="{
            pastel1: t[0].toUpperCase() == 'B',
            pastel2: t[0].toUpperCase() == 'W',
            pastel3: t[0].toUpperCase() == 'I',
            pastel4: t[0].toUpperCase() == 'E',
            pastel5: t[0].toUpperCase() == 'H',
            pastel6: t[0].toUpperCase() == 'P',
            pastel7: t[0].toUpperCase() == 'C',
            pastel9: t[0].toUpperCase() == 'N',
            pastel10: t[0].toUpperCase() == 'g'
          }"
          >{{ t[0] }}</span
        >
      </div>
      <div class="label medium">
        <span v-for="(t, i) in tek.userProfile.tekenprogrammas" :key="i">{{ t }}, </span>
      </div>
      <span class="label extra-small">{{ tek.userProfile.beschikbaarheidInUrenPerWeek || "-" }}</span>
      <div class="label small" style="position: relative;">
        <span v-for="(t, i) in tek.userProfile.berekeningen" :key="i">{{ t }}, </span>
      </div>
      <div class="label medium" style="position: relative;">
        <span v-for="(t, i) in tek.userProfile.nen2580Werkzaamheden" :key="i">{{ t }}, </span>
      </div>
      <span class="label medium">{{ tek.userProfile.plaats || "-" }}</span>
      <span class="label small">{{ tek.userProfile.telefoon || "-" }}</span>
    </div>
    <!-- <div v-else style="font-size:14px; text-align:center; opacity: 0.4;">Leeg profiel. Id = {{ tek.id }}</div> -->
  </div>
</template>

<script>
import store from "../../../../store"

export default {
  name: "ListItem",
  props: ["tek"],
  computed: {
    tingtong() {
      return store.state.selectedUserProfileIndex
    }
  },
  methods: {
    click(id) {
      store.commit("setSelectedUserProfileId", id)
    }
  }
}
</script>

<style scoped>
.disciplines {
  display: flex;
}

.discipline {
  /* background-color: #E4ECFA; */
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  margin-right: -4px;
  font-weight: 500 !important;
  font-size: 11px !important;
  color: #fff !important;
  border: 2px solid white;
}
</style>

<style lang="sass" scoped>

.abs
  position: absolute
  top: 0
  right: 0
  background-color: green
  width: 1rem
  height: 2rem


.tek
  margin: 0 auto
  display: flex
  align-items: center
  width: fit-content
  background-color: white
  padding: 14px
  margin-bottom: 1px
  transition: .2s
  cursor: pointer
  position: relative
  width: 100%
  &::before
    transition: .2s
    position: absolute
    opacity: 0
    content: ''
    inset: 0
    width: 4px
    // height: 10px
    background-color: blue
    transform: translateX(-8px)
    // z-index: 20000
  &:hover
    background-color: hsl(214, 73%, 98%)
    &::before
      transform: translateX(0px)
      opacity: .6
    > .label::before
      opacity: 0
  &.selected
    background-color: #ecf3fc
    &::before
      opacity: 1
      transform: translateX(0)
    > .label::before
      opacity: 0
  > *
    white-space: nowrap
    margin-right: 15px
    min-width: 180px
    // width: 10%

  .label
    &::before
      transition: .2s
      content: ''
      position: absolute
      inset: 0
      overflow: hidden
      background: linear-gradient(-90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 20%)
    overflow-x: hidden
    text-transform: lowercase
    color: rgba(0, 0, 0, 0.6)
    position: relative
    &:first-of-type
      color: rgba(0, 0, 0, 1)
      font-weight: 500
    &.extra-small
      $size: 70px
      min-width: $size
      max-width: $size
    &.small
      $size: 150px
      min-width: $size
      max-width: $size
    &.medium
      $size: 220px
      min-width: $size
      max-width: $size
    &.large
      $size: 240px
      min-width: $size
      max-width: $size



span
  white-space: nowrap
  overflow-x: hidden
  font-size: 15px

.profilePicture
  $size: 32px
  min-width: $size
  max-width: $size
  min-height: $size
  max-height: $size
  border-radius: 100%
  background-color: rgba(0, 0, 0, 0.05)
  background-size: cover
  background-position: center
</style>
